import { createFileRoute } from '@tanstack/react-router';
import { useTranslation } from 'react-i18next';
import { RolesPage } from '@/features/security/roles-page';
import { ConsoleShell } from '@/features/shell/console-shell';

export const Route = createFileRoute('/$tenant/roles/')({ component: RolesRoute });

function RolesRoute() {
  const { tenant } = Route.useParams();
  const { t } = useTranslation();
  return (
    <ConsoleShell tenantId={tenant} activeItem="roles" crumbs={[{ label: t('security.roles.title') }]}>
      <RolesPage tenantId={tenant} />
    </ConsoleShell>
  );
}
